<div class="job-type-switcher" *ngIf="currentUser">

    <!-- Loading state -->
    <div *ngIf="isLoading" class="function-loading d-flex align-items-center">
        <mat-spinner diameter="16"></mat-spinner>
        <span class="loading-text ms-2">Se încarcă...</span>
    </div>

    <!-- Function display with horizontal layout -->
    <div *ngIf="!isLoading && activeAccess"
        class="function-container d-flex flex-row align-items-center justify-content-between gap-3">
        <!-- Active access display -->
        <!-- <div class="current-function d-flex align-items-center"
            [title]="'Accessul activ: ' + activeAccess.functie_name">
            <span class="function-name">{{ activeAccess.functie_name }}</span>
        </div> -->

        <!-- Manage accesses button (only show if user has accesses) -->
        <div *ngIf="userAccesses.length > 0" class="manage-section">
            <button class="manage-functions-btn d-flex flex-column align-items-start" (click)="onManageAccesses()"
                matTooltip="Gestionează accesele">
                <div class="userdir">
                    <!-- <mat-icon class="me-1">settings</mat-icon> -->
                    <span>{{ activeAccess.denumire_directie }}</span>
                </div>
                <div class="usercomp">
                    <span>{{ activeAccess.denumire_compartiment ?? 'n/a' }}</span>
                </div>
            </button>
        </div>
    </div>

    <!-- No accesses warning -->
    <div *ngIf="shouldShowNoAccessWarning()" class="no-function-warning">
        <div class="warning-content d-flex align-items-center" (click)="onManageAccesses()">
            <mat-icon class="warning-icon me-2">warning</mat-icon>
            <span class="warning-text me-2">Nicio direcție</span>
            <mat-icon class="settings-icon">settings</mat-icon>
        </div>
    </div>
</div>